import React, { useState } from "react";
import "./settings.scss";

export default function SettingsPage() {
  const [form, setForm] = useState({
    emsSyncStatus: true,
    consolidateInterval: 24,
    newsValidPeriod: 180,
    siteMaintenance: false,
    mybinaUsername: "",
    mybinaPassword: "",
    mybinaConnectionStatus: "Pending",
    mybinaLastTestedAt: "Not tested yet",
    mybinaLastSyncAt: "Not synced yet",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleTestMyBinaConnection = () => {
    const now = new Date().toLocaleString();

    setForm((prev) => ({
      ...prev,
      mybinaConnectionStatus: "Connected",
      mybinaLastTestedAt: now,
    }));

    alert("myBina connection tested successfully.");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Saving settings", {
      ...form,
      mybinaPassword: form.mybinaPassword ? "********" : "",
    });

    alert("Settings saved successfully.");
  };

  return (
    <div className="settings-page">
      <form onSubmit={handleSubmit}>
        <div className="settings-card">
          <div className="settings-card__header">
            <h2>System Settings</h2>
            <p>
              Configure EMS synchronization, AI consolidation schedule,
              and maintenance mode.
            </p>
          </div>

          <div className="setting-row">
            <div className="setting-row__content">
              <h3>EMS Sync Status</h3>
              <p>
                Enable or disable synchronization between YK Channel and EMS.
              </p>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={form.emsSyncStatus}
                onChange={(e) =>
                  handleChange("emsSyncStatus", e.target.checked)
                }
              />
              <span className="slider" />
            </label>
          </div>

          <div className="setting-row">
            <div className="setting-row__content">
              <h3>Consolidate Interval</h3>
              <p>
                Number of hours between AI lead consolidation runs.
              </p>
            </div>

            <div className="hours-input">
              <input
                type="number"
                min="1"
                value={form.consolidateInterval}
                onChange={(e) =>
                  handleChange(
                    "consolidateInterval",
                    Number(e.target.value)
                  )
                }
              />
              <span>Hours</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-row__content">
              <h3>News Valid Period</h3>
              <p>
                Number of days crawled news remains valid. Older news will be ignored
                during consolidation and lead generation.
              </p>
            </div>

            <div className="hours-input">
              <input
                type="number"
                min="1"
                value={form.newsValidPeriod}
                onChange={(e) =>
                  handleChange(
                    "newsValidPeriod",
                    Number(e.target.value)
                  )
                }
              />
              <span>Days</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-row__content">
              <h3>Site Maintenance</h3>
              <p>
                Enable maintenance mode to temporarily block user access.
              </p>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={form.siteMaintenance}
                onChange={(e) =>
                  handleChange("siteMaintenance", e.target.checked)
                }
              />
              <span className="slider" />
            </label>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card__header settings-card__header--with-status">
            <div>
              <h2>myBina Credential Settings</h2>
              <p>
                Configure the myBina account used by the crawler to download
                project data and reports.
              </p>
            </div>

            <span
              className={`connection-badge connection-badge--${form.mybinaConnectionStatus.toLowerCase()}`}
            >
              {form.mybinaConnectionStatus}
            </span>
          </div>

          <div className="credential-meta">
            <div>
              <label>Connection Status</label>
              <strong>{form.mybinaConnectionStatus}</strong>
            </div>

            <div>
              <label>Last Tested Time</label>
              <strong>{form.mybinaLastTestedAt}</strong>
            </div>

            <div>
              <label>Last Sync Time</label>
              <strong>{form.mybinaLastSyncAt}</strong>
            </div>
          </div>

          <div className="credential-grid">
            <label>
              Username
              <input
                type="text"
                placeholder="Enter myBina username"
                value={form.mybinaUsername}
                onChange={(e) => handleChange("mybinaUsername", e.target.value)}
              />
            </label>

            <label>
              Password
              <input
                type="password"
                placeholder="Enter myBina password"
                value={form.mybinaPassword}
                onChange={(e) => handleChange("mybinaPassword", e.target.value)}
              />
            </label>
          </div>

          <div className="settings-card__footer">
            <button
              type="button"
              className="secondary-button"
              onClick={handleTestMyBinaConnection}
            >
              Test myBina Connection
            </button>

            <button type="submit" className="save-button">
              Save Settings
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
